import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useAuth0 } from "@auth0/auth0-react";

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Button
        variant="contained"
        onClick={() =>
          loginWithRedirect({
            authorizationParams: {
              prompt: "consent",
            },
          })
        }
      >
        Login
      </Button>
    </Box>
  );
};

export default LoginPage;
